import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createHeaders } from '../actionHelpers';
import queryString from 'query-string';

export const ADMIN_STORAGES_CREATE_NOTE = 'ADMIN_STORAGES_CREATE_NOTE';

export const createStorageNote = (storageId, request) => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_STORAGES_CREATE_NOTE),
        endpoint: `/api/admin/storages/${storageId}/notes`,
        headers: createHeaders(true),
        method: 'POST',
        body: JSON.stringify(request)
    }
});


